<template>
  <svg
    width="12"
    height="22"
    viewBox="0 0 12 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.295393 21.7044C-0.0984285 21.3103 -0.0984284 20.6713 0.295393 20.2771L10.2785 10.2862C10.6723 9.89208 11.3108 9.89208 11.7046 10.2862C12.0985 10.6803 12.0985 11.3194 11.7046 11.7135L1.72155 21.7044C1.32773 22.0985 0.689215 22.0985 0.295393 21.7044Z"
      fill="#EDEDED"
    />
    <path
      d="M0.29537 0.295598C0.689192 -0.0985328 1.3277 -0.0985326 1.72152 0.295598L11.7046 10.2862C12.0985 10.6803 12.0985 11.3194 11.7046 11.7135C11.3108 12.1076 10.6723 12.1079 10.2785 11.7138L0.29537 1.72287C-0.0984519 1.32874 -0.0984517 0.689728 0.29537 0.295598Z"
      fill="#EDEDED"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconRightRow',
};
</script>
